(function () {
  function init(root) {
    // Product gallery thumbnails
    root.querySelectorAll('[data-sol-gallery]').forEach(function (g) {
      var views = g.querySelectorAll('.sol-view');
      g.querySelectorAll('.sol-thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-go');
          views.forEach(function (v) { v.classList.toggle('is-on', v.getAttribute('data-view') === i); });
          g.querySelectorAll('.sol-thumb').forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        });
      });
    });

    // Bundle picker: update button price, savings bar and sticky bar
    root.querySelectorAll('[data-sol-form]').forEach(function (form) {
      var amt = form.querySelector('[data-sol-amt]');
      var bar = form.querySelector('[data-sol-savebar]');
      var barText = form.querySelector('[data-sol-savetext]');
      var section = form.closest('[data-sol-pdp]');
      var sticky = section ? section.querySelector('[data-sol-sticky]') : null;
      var stickyMeta = sticky ? sticky.querySelector('[data-sol-sticky-meta]') : null;
      var saveTpl = form.getAttribute('data-save-template') || "You're saving [amount] on this order";
      function render() {
        var r = form.querySelector('input[name="id"]:checked');
        if (!r) return;
        if (amt) amt.textContent = r.getAttribute('data-price');
        var save = r.getAttribute('data-save');
        if (bar) {
          bar.hidden = !save;
          if (save && barText) barText.textContent = saveTpl.replace('[amount]', save);
        }
        if (stickyMeta) stickyMeta.textContent = r.getAttribute('data-label') + ' · ' + r.getAttribute('data-price');
        var inc = r.getAttribute('data-incl');
        form.querySelectorAll('[data-incl-for]').forEach(function (el) { el.hidden = el.getAttribute('data-incl-for') !== inc; });
      }
      form.querySelectorAll('input[name="id"]').forEach(function (r) { r.addEventListener('change', render); });
      render();

      if (sticky) {
        var atc = form.querySelector('.sol-atc');
        var stickyBtn = sticky.querySelector('.sol-atc');
        function check() {
          var gone = window.scrollY > 0 && atc.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-on', gone);
          sticky.setAttribute('aria-hidden', gone ? 'false' : 'true');
          stickyBtn.tabIndex = gone ? 0 : -1;
        }
        window.addEventListener('scroll', check, { passive: true });
        check();
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) { form.requestSubmit(atc); } else { atc.click(); }
        });
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
